import api from './api';
import { ENDPOINTS } from './endpoints';

const SUBSCRIBE_CREATE_PATH = ENDPOINTS.SUBSCRIPTION.CREATE;

export async function createSubscription(email) {
  const payload = { email: email || '' };
  const { data } = await api.post(SUBSCRIBE_CREATE_PATH, payload);
  return data;
}

export default {
  createSubscription,
};
